import React from "react";
import styles from "./styles.css";
import PropTypes from "prop-types";
import LazyImage from "../lazy-image";

const WhyDoYouNeedRwcCard = ({cardIcon, text = "", heading = "", layout = ""}) => {
    return (
        <div styleName={`styles.cardOuter ${layout === "matrix" ? "styles.matrixLayout" : ""}`}>
            <LazyImage src={cardIcon} />
            <div styleName="styles.textContainer">
                {heading && <p styleName={"styles.heading"}>{heading}</p>}
                {text && <p styleName={`styles.text`}>{text}</p>}
            </div>

        </div>
    );
};

WhyDoYouNeedRwcCard.propTypes = {
    cardIcon: PropTypes.string,
    text: PropTypes.string,
    heading: PropTypes.string,
    layout: PropTypes.string
};

export default WhyDoYouNeedRwcCard;

